import { render, staticRenderFns } from "./MetricsPage.vue?vue&type=template&id=6de5b106"
import script from "./MetricsPage.vue?vue&type=script&lang=ts"
export * from "./MetricsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports